export default {
  methods: {
    removeLoading(loadingId) {
      const loadingIcon = document.getElementById(loadingId)
      if (loadingIcon) { loadingIcon.parentNode.removeChild(loadingIcon) }
    },
  },
}